import { Base } from '@or-sdk/base';
import { ContactBookApi, MigrationsApi, ContactApi, FieldSchemaApi, SchemaPresetApi, FilterApi, SharedBookContactPermissionApi, FieldValueApi, } from './api';
import { ApiError } from './apiError';
import BatchProcessApi from './api/batchProcessApi';
import BulkContactsCreateApi from './api/bulkContactsCreateApi';
import { buildBaseConfig, extractTargetDbVersion } from './baseConfigFactory';
import { DB_TARGET_VERSION_HEADER } from './constants';
import AdministrationApi from './api/administrationApi';
export class Contacts extends Base {
    constructor(params) {
        super(buildBaseConfig(params));
        this.targetDbVersion = extractTargetDbVersion(params);
        this.withApiErrorLog = Boolean(params.withApiErrorLog);
        const apiCall = this.callApi.bind(this);
        this.batchProcessApi = new BatchProcessApi(apiCall);
        this.administrationApi = new AdministrationApi(apiCall, this.batchProcessApi);
        this.contactBookApi = new ContactBookApi(apiCall);
        this.migrationsApi = new MigrationsApi(apiCall);
        this.contactApi = new ContactApi(apiCall, this.batchProcessApi, this.contactBookApi);
        this.schemaPresetApi = new SchemaPresetApi(apiCall);
        this.fieldSchemaApi = new FieldSchemaApi(apiCall, this.schemaPresetApi);
        this.filterApi = new FilterApi(apiCall);
        this.sharedBookContactPermissionApi = new SharedBookContactPermissionApi(apiCall);
        this.fieldValueApi = new FieldValueApi(apiCall);
        this.bulkCreateApi = new BulkContactsCreateApi(apiCall, this.batchProcessApi);
    }
    callApi(params) {
        return super.callApiV2(Object.assign(Object.assign({}, params), { customHeaders: Object.assign(Object.assign({}, params.customHeaders), { [DB_TARGET_VERSION_HEADER]: this.targetDbVersion }) }));
    }
    parseError(e) {
        if (e.isAxiosError) {
            const { code, message, stack } = e;
            if (this.withApiErrorLog) {
                this.logApiError(e);
            }
            return new ApiError(code, message, stack);
        }
        const parsedError = super.parseError(e);
        return parsedError;
    }
    logApiError(e) {
        var _a, _b, _c;
        console.error(`url           : ${(_a = e.config) === null || _a === void 0 ? void 0 : _a.url}`);
        console.error(`method        : ${e.request.method}`);
        console.error(`params        : ${JSON.stringify(((_b = e.config) === null || _b === void 0 ? void 0 : _b.params) || {})}`);
        console.error(`data          : ${(() => {
            var _a;
            const str = JSON.stringify(((_a = e.config) === null || _a === void 0 ? void 0 : _a.data) || {});
            return str.length > 150 ? str.slice(0, 149) + '...' : str;
        })()}`);
        console.error(`status code   : ${e.request.res.statusCode}`);
        console.error(`status message: ${e.request.res.statusMessage}`);
        console.error(`authorization : ${(_c = e.config) === null || _c === void 0 ? void 0 : _c.headers.Authorization}`);
    }
}
//# sourceMappingURL=Contacts.js.map